export const ProfileFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.8 9.5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"
    ></path>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.577 19.269A10.46 10.46 0 0 0 22.5 12c0-5.799-4.701-10.5-10.5-10.5S1.5 6.201 1.5 12c0 2.82 1.112 5.38 2.92 7.267h.001A10.47 10.47 0 0 0 12 22.5a10.47 10.47 0 0 0 7.577-3.231m-13.204-1.52-.48 1.2a9 9 0 0 1-.956-.975l.322-.804c.39-.978.648-1.622 1.09-2.108a3.6 3.6 0 0 1 1.415-.958c.614-.23 1.308-.23 2.361-.229h3.75c1.053 0 1.746 0 2.361.229.542.202 1.027.53 1.416.958.44.486.698 1.13 1.089 2.108l.322.804a9 9 0 0 1-.957.974l-.48-1.198c-.454-1.136-.63-1.55-.9-1.847a2.4 2.4 0 0 0-.927-.628c-.376-.14-.825-.15-2.049-.15h-3.5c-1.224 0-1.673.01-2.05.15a2.4 2.4 0 0 0-.927.628c-.27.297-.445.71-.9 1.847M15.05 9.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
      clipRule="evenodd"
    ></path>
  </svg>
);
